import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function PortfolioBacktestingPage() {
  useEffect(() => { document.title = 'Portfolio Backtesting — Test Your Strategy Against History | Nuvport OS'; }, []);
  return <ScaffoldPage badge="BACKTESTING" title="How would your portfolio have performed?" description="Backtest your portfolio against historical data and compare to the S&P 500. Identify which holdings drove returns and which dragged them down." canonical="/features/portfolio-backtesting" />;
}
